<template>
    <div>
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('events.planning.notes.list') }}</h3>
          </div>
          <div class="card-toolbar" >
            <Button btn-class="btn-sm" type="new" btn-text="events.planning.notes.new" @click="openCreateModal"/>
          </div>
        </div>

        <div class="card-body">
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th> {{$t("events.planning.notes.title")}}</th>
              <th class="w-100px">{{$t("actions")}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="notes?.length > 0" v-for="(note, index) in notes" :key="index">
              <td>
                {{ note.title }} <span v-if="note.enabled" class="ms-5 badge badge-light-primary">{{ $t('default') }}</span>
              </td>
              <td>
                <i class="fas fa-edit fs-2 me-5" @click="editnote(note)" :title="$t('button.edit')" :style="{color: Theme.gray}" ></i>
                <i class="fas fa-trash fs-2" @click="deleteNote(note.id)" :title="$t('button.delete')" :style="{color: Theme.gray}" ></i>
              </td>
            </tr>
            <tr v-else class="text-center justify-content-center">
              <td colspan="2">
                <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <NoteModal id="kt_modal_create_note" @load="loadData" :atelier="id"/>
    <NoteModal id="kt_modal_edit_note" @load="loadData" :edit="true" :atelier="id" :form="formEdit"/>
  </template>

  <script setup>
  import { useI18n } from 'vue-i18n'
  import {useStore} from "vuex";
  import { onMounted, ref, computed} from "vue"
  import Button from "@/components/Button.vue"
  import {useSwal} from "@/composables/useSwal";
  import {Theme} from "@/composables/theming";
  import NoteModal from './components/NoteModal.vue';

  const {showSwal} = useSwal()
  const { t } = useI18n({ useScope: 'global' })

  const props = defineProps({
    id: {type: String}
  })

  const formEdit = ref({
    id: '',
    title: '',
    content: '',
    atelier_id: props?.id
  })

  const store = useStore()

  const notes = computed(() => store.getters['notes/getNotes'])

  function loadData() {
    if(props?.id){
        store.dispatch('notes/loadNotes', props?.id)
    }
  }

  onMounted(() => {
    loadData()
  })

  function openCreateModal(){
    $('#kt_modal_create_note').modal('toggle')
  }

  function editnote(note) {
    formEdit.value.id = note.id
    formEdit.value.title = note.title
    formEdit.value.content = note.content
    formEdit.value.enabled = note.enabled

    $('#kt_modal_edit_note').modal('toggle')
  }
  
  async function deleteNote(id){
    showSwal(
        '',
        i18n.global.t('swal.note_deleting')
    ).then( async (result) => {
        if (result.value) {
          try {
            await store.dispatch('notes/deleteNote', id)
            loadData()
            window.toastr.success(t('notifications.note_deleted_successfully'))
          }catch (e) {
          }
        }
    })
  }
  
  </script>
  